// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_jv-0";
export var animationContainer = "_jv-1";
export var itemPrice = "_jv-a";
export var itemizedContent = "_jv-9";
export var itemizedHeader = "_jv-7";
export var itemizedRow = "_jv-8";
export var itemizedSection = "_jv-6";
export var modalContent = "_jv-2";
export var orderName = "_jv-3";
export var refundOption = "_jv-4";
export var refundOptionsContainer = "_jv-5";
export var shippingLabel = "_jv-b";
export var totalRow = "_jv-c";